import React from 'react';
import { Image } from '@fiverr-private/media';
import { useAvatarContext } from '../AvatarContext';
import useMedia from '../hooks/useMedia';
import { AvatarImageProps } from './types';

const AvatarImage = ({ src, lazyLoad = true, alt, ...restProps }: AvatarImageProps) => {
  const { nameValue } = useAvatarContext();
  const { showMedia, isMediaLoaded, onMediaError, onMediaLoad } = useMedia(src, lazyLoad);

  return showMedia ? (
    <Image
      objectFit="cover"
      width="100%"
      height="100%"
      role={'img'}
      position="absolute"
      backgroundColor={isMediaLoaded ? undefined : 'grey_700'}
      src={src}
      alt={alt || nameValue}
      loading={lazyLoad ? 'lazy' : 'eager'}
      onError={onMediaError}
      onLoad={onMediaLoad}
      {...restProps}
    />
  ) : null;
};

AvatarImage.id = 'AvatarImage';
AvatarImage.displayName = 'AvatarImage';

export default AvatarImage;
